import { render, staticRenderFns } from "./BackDatingPosting.vue?vue&type=template&id=5f956ded&scoped=true&"
import script from "./BackDatingPosting.vue?vue&type=script&lang=js&"
export * from "./BackDatingPosting.vue?vue&type=script&lang=js&"
import style0 from "./BackDatingPosting.vue?vue&type=style&index=0&id=5f956ded&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f956ded",
  null
  
)

export default component.exports